import { render } from "./InformationRow.vue?vue&type=template&id=7620810c"
import script from "./InformationRow.vue?vue&type=script&lang=js"
export * from "./InformationRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__